import Dropdown from "~/components/Shared/dropDown.vue";
import AudioPlayer from "~/components/Shared/audioPlayer.vue";
import AyahSelection from "~/components/ayahPage/surahSelection.vue";
import SurahSelectionModal from "~/components/Shared/SurahSelectionModal.vue";
import { mapStores } from "pinia";
import { useAyahStore } from "~/stores/ayah";
import { useQuranStore } from "~/stores/quran";
import { useGlobalStore } from "~/stores/global";

export default {
  setup() {
    const activeAyah = useState('ayah-ayah')
    const activeSurahSate = useState('ayah-surah');
    const activeTab = useState('ayah-tab');
    const activeQariText = ref()

    const shareMenuOpen = ref(false);

    const activeSurah = ref({
      Id: activeSurahSate.value,
    });

    return {
      activeAyah,
      activeSurahSate,
      activeTab,
      activeSurah,
      shareMenuOpen,
      activeQariText
    }
  },
  components: { Dropdown, AyahSelection, AudioPlayer, SurahSelectionModal },
  async beforeMount() {
    await this.fillOrthographyData(), await this.fillAyahData(this.activeSurah);
    await this.fillQariData(this.activeSurah);
  },
  props: {
    facetData: {
      required: true,
    },
    audioSource: {
      type: String,
      required: true,
    },
    selectedAyahObj: {
      type: Object,
      required: true,
    },
    activeOptionFromFacet: {
      type: Object,
      required: true,
    },
    activeQari: {
      type: Number,
      required: false,
    },
  },
  computed: {
    ...mapStores(useAyahStore),
    ...mapStores(useQuranStore),
    ...mapStores(useGlobalStore),
    isMobile() {
      return this.globalStore.isMobile;
    },
    goToQuranPage() {
      let url = `/${this.$i18n.locale}/quran?pagenum=${this.selectedAyahObj?.PageNumber}`

      return url;
    }
  },
  emits: [
    "changeActiveSurah",
    "changeActiveAyah",
    "changeActiveOrthography",
    "changeActiveQari",
    "toggleFullScreen",
    "mobileFacetClicked",
    "getAudioSource",
    "endAudioEvent"
  ],
  data() {
    return {
      ayahListDropDown: [],
      orthographyListDropDown: [],
      qariListDropDown: [],
      activeSurahId: this.activeSurah.Id,
      activeAyahId: this.activeAyah,
      showShareSection: false,
      activeQariText: ""
    };
  },
  watch: {
    activeAyah(to, from) {
      this.activeAyahId = to;
    },
    activeSurahState(to, from) {
      this.activeSurahId = to;
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    handleAutoComplate() {
      // console.log("handleAutoComplate");
    },
    async fillAyahData(surah) {
      const ayahList = await this.ayahStore.getAyahList(surah);
      this.ayahListDropDown = ayahList.map((ayah) => {
        return { id: ayah.Id, name: ayah.Number.toString() };
      });
    },
    async fillOrthographyData() {
      const orthographyList = await this.quranStore.getOrthographyList(
        this.$i18n.locale
      );
      this.orthographyListDropDown = orthographyList.map((orthography) => {
        return { id: orthography.Id, name: orthography.Title };
      });
    },
    async fillQariData(surah) {
      const params = {
        language: this.$i18n.locale,
        surah: surah,
      };

      const qariList = await this.quranStore.getQariList(params)
        .then((qariList) => {
          this.qariListDropDown = qariList.map((qari) => {
            return { id: qari.Id, name: qari.Title, image: qari.ProfileImage };
          });

          this.activeQariText = this.qariListDropDown.filter(qari => qari.id === this.activeQari)[0]?.name;
        });

    },
    changeActiveSurah(selectedSurah) {
      this.activeSurah = selectedSurah;
      this.fillAyahData(selectedSurah);
      this.fillQariData(selectedSurah);
      this.$emit("changeActiveSurah", selectedSurah.Id);
    },
    toggleShareSection() {
      this.showShareSection = !this.showShareSection;
    },
    handleClickOutside(event) {
      if (!this.$refs.shareSection?.contains(event.target)) {
        this.showShareSection = false;
      }
    },
    shareTo(via) {
      let url;
      if (via === "telegram")
        url = `https://telegram.me/share/url?url=${window.location.href}`;
      else if (via === "whatsapp")
        url = `https://api.whatsapp.com/send?text=${window.location.href}`;
      window.location.href = url;
    },
    changeSelectedAyah(ayah) {
      this.$emit("changeActiveAyah", ayah.name);
    },
    changeSelectedOrthography(orthography) {
      this.$emit("changeActiveOrthography", orthography.id);
    },
    changeActiveQari(qari) {
      this.$emit("changeActiveQari", qari.id);
    },
    controlAudio() {
      this.$emit("controlAudio");
    },
    toggleFullScreen() {
      this.$emit("toggleFullScreen");
    },
    mobileFacetClicked(facet) {
      this.$emit("mobileFacetClicked", facet);
    },
    getFacetSelectedCount(facet) {
      var res = this.activeOptionFromFacet.filter(item => item.parentTitle === facet.title).length;

      return res;
    },
    getAudioSource() {
      this.$emit("getAudioSource");
    },
    endAudioEvent() {
      this.$emit("endAudioEvent");
    },
  },
};